const LoaderSizeXL = {
    size: 48,
};
const LoaderSizeLG = {
    size: 32,
};
const LoaderSizeMD = {
    size: 24,
};
const LoaderSizeSM = {
    size: 16,
};

export { LoaderSizeLG, LoaderSizeMD, LoaderSizeSM, LoaderSizeXL };
